import React from 'react';
import '../../resources/css/dialog.css';
import 'react-confirm-alert/src/react-confirm-alert.css';
import {confirmAlert} from "react-confirm-alert";

export const DialogEnum = {
    SUCCESS: 'SUCCESS_ALERT',
    FAIL: 'FAIL_ALERT',
    CONFIRM: 'CONFIRM',
    DELETE: 'DELETE',
    DEFAULT: 'DEFAULT'
}

export const showDialog = (type, header, msg, successFunc) => {
    confirmAlert({
        customUI: ({onClose}) => {
            return (
                <Dialog type={type} header={header} msg={msg} onClose={onClose} successFunc={successFunc}/>
            );
        }
    })
}

/**
 * Dialog Custom Container
 * @param type                  DialogEnum
 * @param header                Dialog 타이틀
 * @param msg                   Dialog 내용 (메시지)
 * @param onClose               Dialog 닫기 버튼
 * @param successFunc           Dialog 확인 버튼 클릭 후 실행할 메서드
 * @returns {JSX.Element}
 * @constructor
 */
const Dialog = ({type, header, msg, onClose, successFunc}) => {
    return (
        <div className="popup-overlay">
            <div className="info_dialog popup-overlay ">
                <div className="dialog_header">
                    <h2>{header}</h2>
                </div>
                <div className="dialog_body">
                    <p>{msg}</p>
                    {/* <div>{msg}</div> */}
                </div>

                <div className="dialog_footer">
                    {(() => {
                        switch (type) {
                            case DialogEnum.SUCCESS
                            :
                                return <button className="success_btn" onClick={() => {
                                    onClose();
                                    if(successFunc != null) successFunc();
                                }
                                }>확인</button>
                            case DialogEnum.FAIL
                            :
                                return <button className="fail_btn" onClick={onClose}>확인</button>
                            case DialogEnum.CONFIRM
                            :
                                return <div className="dialog_btn_wrapper">
                                    <button className="close_btn" onClick={onClose}>취소</button>
                                    <button className="confirm_btn"
                                            onClick={() => {
                                                onClose();
                                                if(successFunc != null) successFunc();
                                            }}
                                    > 확인
                                    </button>
                                </div>
                            case DialogEnum.DELETE
                            :
                                return <div className="dialog_btn_wrapper">
                                    <button className="close_btn" onClick={onClose}>취소</button>
                                    <button className="delete_btn"
                                            onClick={() => {
                                                onClose();
                                                if(successFunc != null) successFunc();
                                            }}
                                    > 확인
                                    </button>
                                </div>
                            case DialogEnum.DEFAULT
                            :
                                return <button className="success_btn" onClick={() => {
                                    onClose();
                                }
                                }>확인</button>
                            default
                            :
                                return <button className="success_btn" onClick={() => {
                                    onClose();
                                }
                                }>확인</button>    
                        }
                    })()}
                </div>
            </div>
        </div>

    );
}
